/**
 * Typing mode configuration
 */
export var TypingMode;
(function (TypingMode) {
    TypingMode["ENGLISH"] = "english";
    TypingMode["BANGLA"] = "bangla";
})(TypingMode || (TypingMode = {}));
/**
 * Digit format configuration
 */
export var DigitFormat;
(function (DigitFormat) {
    DigitFormat["WESTERN"] = "western";
    DigitFormat["BANGLA"] = "bangla";
})(DigitFormat || (DigitFormat = {}));
/**
 * Phonetic parsing mode
 */
export var PhoneticMode;
(function (PhoneticMode) {
    PhoneticMode["SMART"] = "smart";
    PhoneticMode["BASIC"] = "basic";
})(PhoneticMode || (PhoneticMode = {}));
//# sourceMappingURL=types.js.map